import 'reflect-metadata';
import { BeforeInsert, Column, Entity, OneToMany, PrimaryGeneratedColumn } from 'typeorm';
import ClientLieu from './client-lieu.entity';
import { Fournisseur } from './fournisseur.entity';
import { BaseEntite, Entente, EntiteStatique } from './index';
import LieuActivite from './lieu-activite.entity';

@EntiteStatique()
@Entity('lieu')
export class Lieu implements BaseEntite {
    static key = 'lieux';

    @PrimaryGeneratedColumn()
    id: number;

    @Column()
    name: string;

    @Column({ nullable: true })
    adresse: string;

    @Column({ nullable: true })
    code_postal: string;

    @Column({ type: 'timestamp', nullable: true })
    created_at: string;

    @Column({ nullable: true })
    ville: string;

    @Column({ nullable: true })
    province: string;

    @Column({ nullable: true })
    notes: string;

    @OneToMany(() => ClientLieu, (clientLieu: ClientLieu) => clientLieu.lieu)
    clients: ClientLieu[];

    @OneToMany(() => LieuActivite, (lieuActivite: LieuActivite) => lieuActivite.lieu)
    activites: LieuActivite[];

    @OneToMany(() => Fournisseur, (fournisseur: Fournisseur) => fournisseur.lieu)
    fournisseurs: Fournisseur[];

    @OneToMany(() => Entente, (entente: Entente) => entente.lieu)
    ententes: Entente[];

    @BeforeInsert()
    updateCreatedAt(): void {
        this.created_at = new Date().toUTCString();
    }
}
